import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* getReports() {
  yield takeEvery(actions.FETCH_REPORTS_REQUESTED, function* (action) {
    try {
      const reports = yield call(actions.getReports, action.payload);
      yield put({ type: actions.FETCH_REPORTS_SUCCEEDED, reports });
    } catch (error) {
      yield put({ type: actions.FETCH_REPORTS_FAILED, error: error.message });
    }
  });
}

export function* getProductsReports() {
  yield takeEvery(actions.FETCH_PRODUCTS_REPORTS_REQUESTED, function* (action) {
    try {
      const reports = yield call(actions.getProductsReports, action.payload);
      yield put({ type: actions.FETCH_PRODUCTS_REPORTS_SUCCEEDED, reports });
    } catch (error) {
      yield put({
        type: actions.FETCH_PRODUCTS_REPORTS_FAILED,
        error: error.message,
      });
    }
  });
}
export function* deleteReport() {
  yield takeEvery(actions.DELETE_REPORT_REQUESTED, function* (action) {
    try {
      const report = yield call(actions.deleteReport, action.payload);
      yield put({
        type: actions.DELETE_REPORT_REQUESTED,
        reportDeleted: report,
      });
    } catch (error) {
      yield put({ type: actions.DELETE_REPORT_FAILED, error: error.message });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getReports), fork(deleteReport), fork(getProductsReports)]);
}
